import { extendTheme } from "@chakra-ui/react";

export const adminTheme = extendTheme({
    styles: {
        global: {
            // Add hover effect for the Box component
            '.hover-effect:hover': {
            color: 'orange.800', // Change the background color on hover
            cursor: 'pointer', // Change the cursor on hover (optional)
            },
            '.admin-box': {
                padding: '30px', 
                background:'#FFFFFF',
                borderRadius: 'md',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            },
            '.admin-page-header' : {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                margin: '20px 0 20px 0'
            }
        },
    },
});

export const employeeTheme = extendTheme({
    styles: {
        global: {
            // Add hover effect for the Box component
            '.hover-effect:hover': {
            color: 'orange.800', // Change the background color on hover
            cursor: 'pointer', // Change the cursor on hover (optional)
            },
            '.admin-box': {
                padding: '30px', 
                background:'#FFFFFF',
                borderRadius: 'md',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            },
            '.admin-page-header' : {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                margin: '20px 0 20px 0'
            }
        },
    },
});
